import { render, staticRenderFns } from "./MyBraendz.vue?vue&type=template&id=87be3218&scoped=true&"
import script from "./MyBraendz.vue?vue&type=script&lang=ts&"
export * from "./MyBraendz.vue?vue&type=script&lang=ts&"
import style0 from "./MyBraendz.vue?vue&type=style&index=0&id=87be3218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87be3218",
  null
  
)

export default component.exports